import React, { useEffect } from 'react';
import FuelOxMarineHero from '../components/Hero';
import FuelOxBenefitsDemo from '../components/Benefits';
import TestimonialsDemo from '../components/Testimonials';
import { ProductShowcase } from '../components/ProductShowcase';
import { fuelOXProduct } from '../data/products';

const Index = () => {
  // Smooth scroll to section when hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo({
            top: element.getBoundingClientRect().top + window.scrollY - 100,
            behavior: 'smooth'
          });
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    
    // Handle initial page load with hash
    if (window.location.hash) {
      setTimeout(handleHashChange, 500);
    }

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <main className="min-h-screen bg-background">
      {/* Hero Section */}
      <FuelOxMarineHero />
      
      {/* Product Showcase */}
      <section id="products" className="bg-white">
        <ProductShowcase product={fuelOXProduct} />
      </section>
      
      {/* Benefits Section */}
      <section id="benefits" className="bg-gray-50">
        <FuelOxBenefitsDemo />
      </section>
      
      {/* Testimonials Section */}
      <section id="testimonials" className="bg-white">
        <TestimonialsDemo />
      </section>
    </main>
  );
};

export default Index;
